import { render, staticRenderFns } from "./trilateral-flow.vue?vue&type=template&id=04a986fc&scoped=true"
import script from "./trilateral-flow.vue?vue&type=script&lang=js"
export * from "./trilateral-flow.vue?vue&type=script&lang=js"
import style0 from "./trilateral-flow.vue?vue&type=style&index=0&id=04a986fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a986fc",
  null
  
)

export default component.exports